import React, { useState, useRef, useEffect } from "react";
import Login from "./../Pages/Login";
import Register from "./../Pages/Register";
import ChangePassword from "../Pages/ChangePasssword";
import { BASE_URL } from "../../config/api";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./../Styles/new.css";
import "./../Styles/Navbar.css";
import "./../Styles/contact.css";
import "./../Styles/Home.css";
import "./../Styles/footer.css";
import "./../Styles/payment.css";
import "./../Styles/wishlist.css";
import "./../Styles/login.css";
// import "./../Styles/about.css";
import "./../Styles/ragister.css";
import "./../Styles/cart.css";
import "./../Styles/theme.css";

export default function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const previousPageRef = useRef("");

  // States
  const [showLogin, setShowLogin] = useState(false);
  const [showRegister, setShowRegister] = useState(false);
  const [showChangePass, setShowChangePass] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [accountOpen, setAccountOpen] = useState(false);
  const [cartOpen, setCartOpen] = useState(false);
  const [cartItems, setCartItems] = useState([]);
  const [isScrolled, setIsScrolled] = useState(false);
  const [search, setSearch] = useState("");
  const [openMenu, setOpenMenu] = useState(null);
  const [balance, setBalance] = useState(0);
  const [user, setUser] = useState(null);
  const [balanceLoading, setBalanceLoading] = useState(false);
  const [activeCol, setActiveCol] = useState({});
  // Menu states
  const [menuData, setMenuData] = useState([]);
  const [menuLoading, setMenuLoading] = useState(true);
  const [menuError, setMenuError] = useState(null);
  const [desktopMenu, setDesktopMenu] = useState(null);
  const [desktopCol, setDesktopCol] = useState(null);
  const [showScrollTop, setShowScrollTop] = useState(false);
  // Mobile
  const [mobileMenu, setMobileMenu] = useState(null);
  const [mobileCol, setMobileCol] = useState(null);
  const [balanceOpen, setBalanceOpen] = useState(false);
  const dropdownRef = useRef();
  const searchParams = new URLSearchParams(location.search);
  const activeCid = searchParams.get("cid");
  const [subCategoryImages, setSubCategoryImages] = useState([]);
  // ==================== SEARCH FUNCTION (FIXED!) ====================
  // ==================== SEARCH FUNCTION (DEBUG VERSION) ====================
  const handleSearch = async () => {
    const trimmedSearch = search.trim();

    if (!trimmedSearch || trimmedSearch.length < 2) {
      alert("Please enter valid Design Code");
      return;
    }

    try {
      const response = await fetch(
        `${BASE_URL}/design-search.php?code=${encodeURIComponent(trimmedSearch)}`,
      );

      if (!response.ok) {
        throw new Error(`HTTP Error: ${response.status}`);
      }

      const result = await response.json();

      // console.log("Search Result:", result);

      let searchData = [];

      if (result?.success && Array.isArray(result?.data)) {
        searchData = result.data;
      }

      if (searchData.length > 0) {
        const foundDesign = searchData[0];

        navigate(
          `/category?code=${foundDesign.code}&cid=${foundDesign.cid}&subcid=${foundDesign.scid}&icid=${foundDesign.icid}&menu=${encodeURIComponent(foundDesign.categoryname)}`,
        );

        setSearch("");
      } else {
        alert("Design not found");
      }
    } catch (error) {
      console.error("Search Error:", error);
      alert("Search failed");
    }
  };
  // ==================== API FETCH FUNCTIONS ====================

  const fetchMenuData = async () => {
    try {
      setMenuLoading(true);
      setMenuError(null);

      let result;

      // Method 1: Direct fetch
      try {
        const directResponse = await fetch(
          "https://lifetimedesign.in/LtcJsonAPI.asmx/GetMenuDesigns",
        );
        result = await directResponse.json();
      } catch (directError) {
        // console.log("🌐 Direct fetch blocked by CORS, trying proxy...");

        // Method 2: CORS Proxy
        const proxyUrl =
          "https://api.allorigins.win/raw?url=" +
          encodeURIComponent(
            "https://lifetimedesign.in/LtcJsonAPI.asmx/GetMenuDesigns",
          );
        const proxyResponse = await fetch(proxyUrl);
        result = await proxyResponse.json();
      }

      // ✅ Handle YOUR EXACT API STRUCTURE
      const menuArray = result.data || result.d || result;

      if (Array.isArray(menuArray) && menuArray.length > 0) {
        const transformedMenu = transformMenuData(menuArray);
        setMenuData(transformedMenu);
        return;
      }

      throw new Error("No menu data found");
    } catch (apiError) {
      console.error("❌ API Failed:", apiError);

      // ✅ Bulletproof fallback matching your sample
      const fallbackData = [
        // {
        //   id: 30,
        //   name: "FREE DOWNLOAD",
        //   count: 107,
        //   subcategories: [
        //     {
        //       id: 148,
        //       name: "OPEN DESIGN",
        //       count: 77,
        //       innercategories: [{ id: 381, name: "MALTI DESIGN", count: 77 }],
        //     },
        //     {
        //       id: 91,
        //       name: "BEST OFFER ON BALANCE",
        //       count: 1,
        //       innercategories: [{ id: 350, name: "CLICK HERE", count: 1 }],
        //     },
        //   ],
        // },
        // {
        //   id: 38,
        //   name: "BEADS DESIGN",
        //   count: 15,
        //   subcategories: [
        //     {
        //       id: 172,
        //       name: "kLI-DESIGN (No-Offer)",
        //       count: 15,
        //       innercategories: [{ id: 476, name: "No- 1 To 100", count: 15 }],
        //     },
        //   ],
        // },
        // {
        //   id: 24,
        //   name: "LTC DESIGN",
        //   count: 1033,
        //   subcategories: [
        //     {
        //       id: 138,
        //       name: "SEQUIENCE",
        //       count: 103,
        //       innercategories: [
        //         { id: 353, name: "1-100 (LTC-SQ)", count: 90 },
        //         { id: 455, name: "DUAL SEQUIN", count: 13 },
        //       ],
        //     },
        //     {
        //       id: 69,
        //       name: "DAMAN",
        //       count: 306,
        //       innercategories: [
        //         { id: 168, name: "1-500 (LTC-DM)", count: 306 },
        //       ],
        //     },
        //     {
        //       id: 70,
        //       name: "PATLI",
        //       count: 71,
        //       innercategories: [{ id: 169, name: "1-500 (LTC-PM)", count: 71 }],
        //     },
        //   ],
        // },
      ];

      const transformedFallback = transformMenuData(fallbackData);
      setMenuData(transformedFallback);
      setMenuError("Using backup menu");
    } finally {
      setMenuLoading(false);
    }
  };
  const handlePageOpen = (path, type = "normal") => {
    const openedPages = JSON.parse(localStorage.getItem("openedPages")) || [];

    // Wishlist / Cart / Orders
    if (["wishlist", "cart", "orders"].includes(type)) {
      if (openedPages.includes(path)) {
        navigate(path);
      } else {
        window.open(path, "_blank");

        openedPages.push(path);
        localStorage.setItem("openedPages", JSON.stringify(openedPages));
      }
      return;
    }

    // Top menu links
    let menuCount = Number(localStorage.getItem("topMenuCount")) || 0;

    if (menuCount < 2) {
      window.open(path, "_blank");
      localStorage.setItem("topMenuCount", menuCount + 1);
    } else {
      navigate(path);
    }
  };
  const transformMenuData = (apiData) => {
    return apiData.map((category) => ({
      id: category.id,
      title: category.name,
      key: `menu_${category.id}`,
      columns:
        category.subcategories?.map((subcat) => ({
          id: subcat.id,
          heading: subcat.name,

          image: imageMap[subcat.id]
            ? `https://lifetimedesign.in/controlpanel/Designs/${imageMap[subcat.id]}`
            : "/images/categories/default.jpg",

          links:
            subcat.innercategories?.map((inner) => ({
              id: inner.id,
              label: inner.name,
              url: `/category?cid=${category.id}&subcid=${subcat.id}&icid=${inner.id}&menu=${encodeURIComponent(category.name)}`,
            })) || [],
        })) || [],
    }));
  };
  const removeFromCart = async (cartId) => {
    try {
      const userId = user?.user_login_id || user?.id;

      await fetch(
        `https://lifetimedesign.in/LtcJsonAPI.asmx/RemoveCartDesign?cart_id=${cartId}&user_id=${userId}`,
      );

      setCartItems((prev) => prev.filter((item) => item.cart_id !== cartId));

      setCounts((prev) => ({
        ...prev,
        cart: Math.max(0, prev.cart - 1),
      }));

      window.dispatchEvent(new Event("cartUpdated"));
    } catch (error) {
      console.error("Cart remove error:", error);
    }
  };
  // Balance fetch
  // const fetchBalance = async (userId) => {
  //   try {
  //     const res = await fetch(`${BASE_URL}/get-balance.php?userid=${userId}`);

  //     const data = await res.json();

  //     let parsed = data;

  //     if (data.d) {
  //       parsed = typeof data.d === "string" ? JSON.parse(data.d) : data.d;
  //     }

  //     const newBalance = Number(
  //       parsed?.data?.currentbalance || parsed?.currentbalance || 0,
  //     );

  //     setBalance(newBalance);

  //     const loginUser = JSON.parse(localStorage.getItem("user"));

  //     if (loginUser) {
  //       loginUser.balance = newBalance;
  //       localStorage.setItem("user", JSON.stringify(loginUser));
  //     }
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  // Balance fetch from LTC API
  const fetchBalance = async (userId) => {
    try {
      setBalanceLoading(true);

      const response = await fetch(
        `https://lifetimedesign.in/LtcJsonAPI.asmx/GetBalance?userid=${userId}`,
      );

      const data = await response.json();

      console.log("Balance API Response:", data);

      let parsed = data;

      // ASP.NET WebMethod response handling
      if (data.d) {
        parsed = typeof data.d === "string" ? JSON.parse(data.d) : data.d;
      }

      const newBalance = Number(
        parsed?.data?.currentbalance ||
          parsed?.currentbalance ||
          parsed?.balance ||
          0,
      );

      setBalance(newBalance);

      setBalance(newBalance);

      const loginUser = JSON.parse(localStorage.getItem("user"));

      if (loginUser) {
        loginUser.balance = newBalance;

        localStorage.setItem("user", JSON.stringify(loginUser));
      }
    } catch (error) {
      console.error("Balance Fetch Error:", error);
      setBalance(0);
    } finally {
      setBalanceLoading(false);
    }
  };

  // Counts
  const [counts, setCounts] = useState({ wishlist: 0, cart: 0, orders: 0 });

  // Update the updateLocalCounts function
  const updateLocalCounts = async () => {
    const loginUser = JSON.parse(localStorage.getItem("user"));

    if (!loginUser?.id) {
      setCounts({
        wishlist: 0,
        cart: 0,
        orders: 0,
      });
      return;
    }

    try {
      // Wishlist Count
      const wishlistRes = await fetch(
        `https://lifetimedesign.in/LtcJsonAPI.asmx/Getwishlist?user_id=${loginUser.id}`,
      );
      const wishlistData = await wishlistRes.json();

      // Cart Count
      const cartRes = await fetch(
        `https://lifetimedesign.in/LtcJsonAPI.asmx/Getcartlist?user_id=${loginUser.id}`,
      );
      const cartData = await cartRes.json();

      // Safe extraction
      const wishlistCount = Array.isArray(wishlistData?.data)
        ? wishlistData.data.length
        : 0;

      const cartList = Array.isArray(cartData?.data) ? cartData.data : [];

      const cartCount = cartList.length;

      setCounts({
        wishlist: wishlistCount,
        cart: cartCount,
        orders: 0,
      });

      setCartItems(cartList);
    } catch (error) {
      console.error("❌ Error updating counts:", error);
    }
  };

  // ==================== USE EFFECTS ====================

  useEffect(() => {
    if (subCategoryImages.length > 0) {
      fetchMenuData();
    }
  }, [subCategoryImages]);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;

      setIsScrolled(scrollY > 100);
      setShowScrollTop(scrollY > 300); // show button after 300px
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    updateLocalCounts();

    window.addEventListener("cartUpdated", updateLocalCounts);
    window.addEventListener("wishlistUpdated", updateLocalCounts);
    window.addEventListener("userLogin", updateLocalCounts);

    return () => {
      window.removeEventListener("cartUpdated", updateLocalCounts);
      window.removeEventListener("wishlistUpdated", updateLocalCounts);
      window.removeEventListener("userLogin", updateLocalCounts);
    };
  }, []);

  useEffect(() => {
    const loadUser = () => {
      try {
        const loginUserRaw = localStorage.getItem("user");

        if (!loginUserRaw) {
          setUser(null);
          setBalance(0);
          return;
        }

        const loginUser = JSON.parse(loginUserRaw);

        setUser(loginUser);

        if (loginUser?.id || loginUser?.user_login_id) {
          fetchBalance(loginUser.id || loginUser.user_login_id);
        }
      } catch (error) {
        console.error("❌ Navbar: Parse error:", error);
        setUser(null);
        setBalance(0);
      }
    };

    loadUser();

    window.addEventListener("userLogin", loadUser);
    const handleUserLogout = () => {
      setUser(null);
      setBalance(0);
      setCartItems([]);

      setCounts({
        wishlist: 0,
        cart: 0,
        orders: 0,
      });

      setCartOpen(false);
    };

    window.addEventListener("userLogout", handleUserLogout);

    return () => {
      window.removeEventListener("userLogin", loadUser);
      window.removeEventListener("userLogout", handleUserLogout);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setAccountOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);
  useEffect(() => {
    const updateBalanceFromStorage = async () => {
      const loginUser = JSON.parse(localStorage.getItem("user"));

      if (!loginUser) return;

      const userId = loginUser.user_login_id || loginUser.id;

      if (userId) {
        await fetchBalance(userId);
      }
    };

    window.addEventListener("balanceUpdated", updateBalanceFromStorage);

    return () => {
      window.removeEventListener("balanceUpdated", updateBalanceFromStorage);
    };
  }, []);

  useEffect(() => {
    fetch(
      "https://lifetimedesign.in/LtcJsonAPI.asmx/GetLatestSubCategoryImages",
    )
      .then((res) => res.json())
      .then((res) => {
        setSubCategoryImages(res.data);
      });
  }, []);
  const imageMap = subCategoryImages.reduce((map, item) => {
    map[item.subcategory_id] = item.image_url;
    return map;
  }, {});
  // ==================== HANDLERS ====================

  // const handleLogout = () => {
  //   localStorage.removeItem("user");
  //   setUser(null);
  //   window.dispatchEvent(new Event("userLogout"));
  //   setAccountOpen(false);
  //   navigate("/");
  // };

  const handleLogout = (openLogin = false) => {
    localStorage.removeItem("user");
    localStorage.removeItem("token");

    window.dispatchEvent(new Event("userLogout"));

    setAccountOpen(false);
    setUser(null);

    // Clear balance
    setBalance(0);

    // Clear cart data immediately
    setCartItems([]);

    // Reset counts
    setCounts({
      wishlist: 0,
      cart: 0,
      orders: 0,
    });

    // Close cart dropdown
    setCartOpen(false);

    if (openLogin) {
      setShowLogin(true);
    }

    navigate("/");
  };
  // ==================== RENDER ====================
  const [topMenuOpen, setTopMenuOpen] = useState(false);
  // const [activeCol, setActiveCol] = useState(0);
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // useEffect(() => {
  //   const timer = setTimeout(async () => {
  //     const value = search.trim();

  //     // Search box cleared -> go back to previous page
  //     if (value === "") {
  //       if (previousPageRef.current) {
  //         navigate(previousPageRef.current, { replace: true });
  //       }
  //       return;
  //     }

  //     // Wait until at least 2 characters
  //     if (value.length < 2) return;

  //     // Save current page only once
  //     if (!previousPageRef.current) {
  //       previousPageRef.current = location.pathname + location.search;
  //     }

  //     try {
  //       const response = await fetch(
  //         `${BASE_URL}/design-search.php?code=${encodeURIComponent(value)}`,
  //       );

  //       const result = await response.json();

  //       if (result?.success && result?.data?.length > 0) {
  //         const design = result.data[0];

  //         navigate(
  //           `/category?code=${design.code}&cid=${design.cid}&subcid=${design.scid}&icid=${design.icid}&menu=${encodeURIComponent(design.categoryname)}`,
  //           { replace: true },
  //         );
  //       }
  //     } catch (err) {
  //       console.error(err);
  //     }
  //   }, 400);

  //   return () => clearTimeout(timer);
  // }, [search]);

  // useEffect(() => {
  //   const value = search.trim();

  //   if (value.length < 2) {
  //     return;
  //   }

  //   const timer = setTimeout(async () => {
  //     try {
  //       const response = await fetch(
  //         `${BASE_URL}/design-search.php?code=${encodeURIComponent(value)}`,
  //       );

  //       const result = await response.json();

  //       if (result?.success && result?.data?.length > 0) {
  //         const design = result.data[0];

  //         navigate(
  //           `/category?code=${design.code}&cid=${design.cid}&subcid=${design.scid}&icid=${design.icid}&menu=${encodeURIComponent(design.categoryname)}`,
  //           { replace: true },
  //         );
  //       }
  //     } catch (err) {
  //       console.error(err);
  //     }
  //   }, 400);

  //   return () => clearTimeout(timer);
  // }, [search, navigate]);
  // useEffect(() => {
  //   if (search === "") {
  //     previousPageRef.current = "";
  //   }
  // }, [location.pathname, location.search]);

  useEffect(() => {
    const value = search.trim();

    // Search cleared -> go back to previous page
    if (value === "") {
      if (previousPageRef.current) {
        navigate(previousPageRef.current, { replace: true });
        previousPageRef.current = "";
      }
      return;
    }

    // Save current page before first search
    if (!previousPageRef.current) {
      previousPageRef.current = location.pathname + location.search;
    }

    if (value.length < 2) return;

    const timer = setTimeout(async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/design-search.php?code=${encodeURIComponent(value)}`,
        );

        const result = await response.json();

        if (result?.success && result?.data?.length > 0) {
          const design = result.data[0];

          navigate(
            `/category?code=${design.code}&cid=${design.cid}&subcid=${design.scid}&icid=${design.icid}&menu=${encodeURIComponent(design.categoryname)}`,
            { replace: true },
          );
        }
      } catch (err) {
        console.error(err);
      }
    }, 400);

    return () => clearTimeout(timer);
  }, [search, navigate, location.pathname, location.search]);
  return (
    <>
      {/* ================= TOP HEADER ================= */}
      <div
        className={`ltc-top-header ${isScrolled ? "ltc-header-scrolled" : ""}`}
      >
        <div className="container-fluid ltc-nav-wrapper">
          <div
            className="ltc-mobile-toggle"
            onClick={() => setTopMenuOpen(!topMenuOpen)}
          >
            <i className={`bi ${menuOpen ? "bi-x-lg" : "bi-list"}`}></i>
          </div>

          <div className={`ltc-top-links ${topMenuOpen ? "ltc-open" : ""}`}>
            <Link to="/how-to-use">HOW TO USE</Link>
            <Link to="/offers">OFFERS</Link>
            <Link to="/ads">ADS</Link>
            <Link to="/latest-design">LATEST DESIGN</Link>
            <Link to="/news">LATEST UPDATE NEWS</Link>
            <Link to="/payment-methods" target="_blank">
              PAYMENT METHODS
            </Link>

            {user && (
              <Link to="/myorders" target="_blank">
                DOWNLOAD DESIGNS
              </Link>
            )}
            <Link to="/gallery" target="_blank">
              GALLERY
            </Link>
            <Link to="/contact">CONTACT US</Link>
            <Link to="/Service">SERVICES</Link>
            <Link
              to="https://play.google.com/store/apps/details?id=gnhub.ltc"
              target="_blank"
              className="ltc-download-btn"
            >
              DOWNLOAD APP
            </Link>
          </div>
        </div>
      </div>

      {/* ================= MAIN HEADER (Logo + Search + Contact) ================= */}
      <div className="ltcx-header-wrap">
        <div className="container-fluid ltcx-header-inner">
          <div className="ltcx-logo-area">
            <Link to="/Home">
              <img src="images/logo.png" alt="LTC Logo" className="ltcx-logo" />
            </Link>
          </div>

          <div className="ltcx-search-area">
            <div className="ltcx-search-box">
              {/* <input
                type="text"
                className="ltcx-search-input"
                placeholder="Search Design Code"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                onKeyDown={(e) => e.key === "Enter" && handleSearch()}
              /> */}

              <input
                type="text"
                className="ltcx-search-input"
                placeholder="Search Design Code"
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />

              <button className="ltcx-search-btn" onClick={handleSearch}>
                <i className="bi bi-search"></i>
              </button>
            </div>
          </div>

          <div className="ltcx-right-panel">
            <div className="ltcx-contact-card">
              <span>CALL US NOW</span>
              <strong>+91 98791 96990</strong>
              <strong>+91 99096 14445</strong>
            </div>

            <div
              className="ltcx-wallet-card ltcx-wallet-clickable"
              onMouseEnter={() => setBalanceOpen(true)}
              onMouseLeave={() => setBalanceOpen(false)}
            >
              <i className="bi bi-wallet2"></i>

              <div>
                <small>Balance</small>
                <h6>
                  <span className="rupee-symbol">₹</span>{" "}
                  {balanceLoading
                    ? "..."
                    : Number(balance || 0).toLocaleString("en-IN")}
                </h6>
              </div>

              {/* 🔽 BALANCE DROPDOWN */}
              {balanceOpen && (
                <div className="ltc-ba-dropdown">
                  <button
                    className="ltc-balance-item"
                    onClick={() => {
                      if (user) {
                        navigate("/balance");
                      } else {
                        setShowLogin(true);
                      }
                      setBalanceOpen(false);
                    }}
                  >
                    Balance & Passbook
                  </button>
                </div>
              )}
            </div>

            <div className="navbar-interaction-group">
              <div
                className="nav-item-container1"
                title="Wishlist"
                onClick={() => handlePageOpen("/wishlist", "wishlist")}
              >
                <i className="bi bi-heart"></i>
                {counts.wishlist > 0 && (
                  <span className="status-indicator">{counts.wishlist}</span>
                )}
              </div>
              {/* <Link
                to="/cart"
                target="_blank"
                className="nav-item-container1"
                title="Cart"
              >
                <i className="bi bi-cart"></i>
                 {counts.cart > 0 && (
                  <span className="status-indicator">{counts.cart}</span>
                )} 
              </Link> */}
              <div
                className="ltc-cart-wrapper"
                onMouseEnter={() => setCartOpen(true)}
                onMouseLeave={() => setCartOpen(false)}
              >
                <div
                  className="nav-item-container1"
                  title="Cart"
                  onClick={() => handlePageOpen("/cart", "cart")}
                >
                  <i className="bi bi-cart"></i>
                  {counts.cart > 0 && (
                    <span className="status-indicator">{counts.cart}</span>
                  )}
                </div>

                {/* DROPDOWN */}
                {user && cartOpen && (
                  <div className="ltc-cart-dropdown">
                    {cartItems.length > 0 ? (
                      <>
                        <div className="ltc-cart-list">
                          {cartItems.map((item, i) => (
                            <div key={i} className="ltc-cart-item">
                              <button
                                className="cart-remove-btn"
                                onClick={(e) => {
                                  e.stopPropagation();

                                  // console.log(
                                  //   "Removing Cart ID:",
                                  //   item.cart_id,
                                  // );
                                  // console.log("Item Data:", item);

                                  removeFromCart(item.cart_id);
                                }}
                              >
                                ✕
                              </button>
                              <div>{i + 1}</div>
                              <img
                                src={`https://lifetimedesign.in/controlpanel/Designs/${item.image_url}`}
                                alt=""
                              />
                              <div className="cart-menu">
                                <div>
                                  <strong>Code:</strong>
                                  {item.code}
                                </div>
                                <div>
                                  <strong>Price: </strong>₹ {item.price}
                                </div>
                                <div>
                                  <strong>Stitch: </strong>
                                  {item.stitch}
                                </div>
                                <div>
                                  {" "}
                                  <strong>Color:</strong>
                                  {item.color}
                                </div>
                                <div>
                                  {" "}
                                  <strong>Area:</strong> {item.area}
                                </div>
                                <div>
                                  <strong>Details:</strong> {item.description}
                                </div>
                                <div>
                                  <strong>Height: </strong>
                                  {item.packageno}
                                </div>
                                <div>
                                  <strong>Width:</strong>
                                  {item.sequence}
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>

                        <div className="ltc-cart-footer">
                          <strong>
                            Total ₹{" "}
                            {cartItems.reduce(
                              (sum, i) => sum + Number(i.price),
                              0,
                            )}
                          </strong>

                          <Link to="/cart" className="ltc-checkout-btn">
                            Checkout
                          </Link>
                        </div>
                      </>
                    ) : (
                      <div className="ltc-empty-cart">Cart is empty</div>
                    )}
                  </div>
                )}
              </div>
              <div
                className="nav-item-container1"
                title="Orders"
                onClick={() => handlePageOpen("/myorders", "orders")}
              >
                <i className="bi bi-bag-check"></i>
                {counts.orders > 0 && (
                  <span className="status-indicator status-green">
                    {counts.orders}
                  </span>
                )}
              </div>
            </div>

            {/* <div className="ltcx-account-btn">
              <i className="bi bi-person-circle"></i>
              <span>{user ? user.name : "Account"}</span>
            </div> */}

            <div className="ltcx-account-wrapper" ref={dropdownRef}>
              <div
                className="ltcx-account-btn"
                onClick={() => setAccountOpen(!accountOpen)}
              >
                <i className="bi bi-person-circle"></i>
                <span>{user ? user.name : "My Account"}</span>
                <i className="bi bi-chevron-down"></i>
              </div>

              {accountOpen && (
                <div className="ltcx-account-dropdown">
                  {user ? (
                    <>
                      <button
                        onClick={() => {
                          navigate("/myorders");
                          setAccountOpen(false);
                        }}
                      >
                        <i className="bi bi-bag"></i>
                        My Orders
                      </button>
                      <button
                        onClick={() => {
                          navigate("/wishlist");
                          setAccountOpen(false);
                        }}
                      >
                        <i className="bi bi-heart"></i>
                        Wishlist
                      </button>
                      <button
                        onClick={() => {
                          navigate("/balance");
                          setAccountOpen(false);
                        }}
                      >
                        <i className="bi bi-wallet2"></i>
                        Add Balance & Passbook
                      </button>
                      <button
                        onClick={() => {
                          setShowChangePass(true);
                          setAccountOpen(false);
                        }}
                      >
                        <i className="bi bi-key"></i>
                        Change Password
                      </button>

                      <button
                        onClick={() => {
                          handleLogout(true);
                          setAccountOpen(false);
                        }}
                      >
                        <i className="bi bi-box-arrow-right"></i>
                        Logout
                      </button>
                    </>
                  ) : (
                    <>
                      <button
                        onClick={() => {
                          setShowLogin(true);
                          setAccountOpen(false);
                        }}
                      >
                        <i className="bi bi-box-arrow-in-right"></i>
                        Login
                      </button>

                      <button
                        onClick={() => {
                          setShowRegister(true);
                          setAccountOpen(false);
                        }}
                      >
                        <i className="bi bi-person-plus"></i>
                        Register
                      </button>
                    </>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* ================= MAIN NAVBAR (Menu Bar) ================= */}

      <div className={`fly-nav ${isScrolled ? "scrolled" : ""}`}>
        <div className="fly-container">
          <div
            className="ltc-mobile-menu-btn"
            onClick={() => setMenuOpen(!menuOpen)}
          >
            <i className={`bi ${menuOpen ? "bi-x-lg" : "bi-list"}`}></i>
          </div>
          {/* Mobile Toggle Button */}
          <div className="nav-links">
            {menuLoading ? (
              <div className="menuLoading">
                <div
                  className="spinner-border spinner-border-sm me-2"
                  role="status"
                ></div>
                Loading menu...
              </div>
            ) : menuData.length === 0 ? (
              <div className="no-menu text-muted">No menus available</div>
            ) : (
              menuData.map((menuItem) => (
                // <div
                //   key={menuItem.key || menuItem.id}
                //   className={`nav-item dropdown ${
                //     String(menuItem.id) === activeCid ? "menu-active" : ""
                //   } ${desktopMenu === menuItem.key ? "active" : ""}`}
                //   onMouseEnter={() => setDesktopMenu(menuItem.key)}
                //   onMouseLeave={() => {
                //     setDesktopMenu(null);
                //     setDesktopCol(0);
                //   }}
                // >
                <div
                  key={menuItem.key || menuItem.id}
                  className={`nav-item dropdown ${
                    String(menuItem.id) === activeCid ? "menu-active" : ""
                  } ${desktopMenu === menuItem.key ? "active" : ""}`}
                  onClick={() => {
                    setDesktopMenu(
                      desktopMenu === menuItem.key ? null : menuItem.key,
                    );
                  }}
                  onMouseLeave={() => {
                    setDesktopMenu(null);
                    setDesktopCol(0);
                  }}
                >
                  <div
                    className="dropdown-toggle"
                    onClick={() => {
                      setDesktopMenu(
                        desktopMenu === menuItem.key ? null : menuItem.key,
                      );
                      setDesktopCol(0);
                    }}
                  >
                    {menuItem.title}
                  </div>

                  {desktopMenu === menuItem.key && (
                    <div className="ltc-mega-menu">
                      <div className="ltc-sidebar">
                        {menuItem.columns.map((column, index) => (
                          <div
                            key={index}
                            className={`ltc-category ${
                              desktopCol === index ? "active" : ""
                            }`}
                            onMouseEnter={() => setDesktopCol(index)}
                            onClick={() => {
                              const firstInner = column.links?.[0];

                              if (firstInner) {
                                navigate(firstInner.url);
                                setDesktopMenu(null);
                                setDesktopCol(0);
                              }
                            }}
                          >
                            {column.heading}
                            <span className="arrow">›</span>
                          </div>
                        ))}
                      </div>

                      <div className="ltc-content">
                        {menuItem.columns[desktopCol]?.links?.map(
                          (link, index) => (
                            <Link
                              key={index}
                              to={link.url}
                              className="ltc-submenu-link1"
                              onClick={() => {
                                window.scrollTo({
                                  top: 0,
                                  behavior: "smooth",
                                });

                                setDesktopMenu(null);
                                setDesktopCol(0);
                              }}
                            >
                              {link.label}
                            </Link>
                          ),
                        )}
                      </div>

                      <div className="ltc-image">
                        <img
                          src={menuItem.columns[desktopCol]?.image}
                          alt="category"
                          onError={(e) => {
                            e.target.src = "/images/categories/default.jpg";
                          }}
                        />
                      </div>
                    </div>
                  )}
                </div>
              ))
            )}
          </div>
          <div className={`mobile-side-menu ${menuOpen ? "show" : ""}`}>
            <div className="mobile-side-header">
              <button
                className="mobile-close"
                onClick={() => {
                  setMenuOpen(false);
                  setMobileMenu(null);
                  setMobileCol(null);
                }}
              >
                ✕
              </button>
            </div>

            {menuLoading ? (
              <div className="mobile-loading">Loading menu...</div>
            ) : menuData.length === 0 ? (
              <div className="mobile-empty">No menus available</div>
            ) : (
              menuData.map((menuItem) => (
                <div
                  key={menuItem.key || menuItem.id}
                  className="mobile-main-item"
                >
                  <div
                    className="mobile-main-link"
                    onClick={() => {
                      setMobileMenu(
                        mobileMenu === menuItem.key ? null : menuItem.key,
                      );

                      setMobileCol(null);
                    }}
                  >
                    <span>{menuItem.title}</span>

                    <span>{mobileMenu === menuItem.key ? "−" : "+"}</span>
                  </div>

                  {mobileMenu === menuItem.key && (
                    <div className="mobile-sub-menu">
                      {menuItem.columns.map((column, index) => {
                        const columnKey = `${menuItem.key}-${index}`;

                        return (
                          <div key={index} className="mobile-sub-item">
                            <div
                              className="mobile-sub-heading"
                              onClick={() =>
                                setMobileCol(
                                  mobileCol === columnKey ? null : columnKey,
                                )
                              }
                            >
                              <span>{column.heading}</span>

                              <span>{mobileCol === columnKey ? "−" : "+"}</span>
                            </div>

                            {mobileCol === columnKey && (
                              <div className="mobile-inner-menu">
                                {column.links.map((link, i) => (
                                  <Link
                                    key={i}
                                    to={link.url}
                                    className="mobile-inner-link"
                                    onClick={() => {
                                      setMenuOpen(false);
                                      setMobileMenu(null);
                                      setMobileCol(null);
                                    }}
                                  >
                                    {link.label}
                                  </Link>
                                ))}
                              </div>
                            )}
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              ))
            )}
          </div>

          {/* ICONS */}
          {isScrolled && (
            <div className="ltc-fly-icons">
              <Link to="/wishlist" target="_blank" className="ltc-fly-btn">
                <i className="bi bi-heart"></i>
                {counts.wishlist > 0 && (
                  <span className="ltc-fly-badge">{counts.wishlist}</span>
                )}
              </Link>

              <Link to="/cart" target="_blank" className="ltc-fly-btn">
                <i className="bi bi-cart3"></i>
                {counts.cart > 0 && (
                  <span className="ltc-fly-badge">{counts.cart}</span>
                )}
              </Link>

              <div
                className="ltc-fly-btn"
                onClick={() => handlePageOpen("/myorders", "orders")}
              >
                <i className="bi bi-bag-check"></i>
                {counts.orders > 0 && (
                  <span className="ltc-fly-badge">{counts.orders}</span>
                )}
              </div>
            </div>
          )}
        </div>
      </div>

      {/* ================= MODALS ================= */}
      <Login
        isOpen={showLogin}
        onClose={() => setShowLogin(false)}
        openRegister={() => {
          setShowLogin(false);
          setShowRegister(true);
        }}
      />
      <Register
        isOpen={showRegister}
        onClose={() => setShowRegister(false)}
        openLogin={() => {
          setShowRegister(false);
          setShowLogin(true);
        }}
      />
      <ChangePassword
        isOpen={showChangePass}
        onClose={() => setShowChangePass(false)}
        onLogout={() => {
          handleLogout(true); // ✅ IMPORTANT
        }}
      />
      {showScrollTop && (
        <button
          className="scroll-top-btn"
          onClick={scrollToTop}
          aria-label="Scroll to top"
        >
          <i className="bi bi-arrow-up"></i>
        </button>
      )}
    </>
  );
}
